import { render, staticRenderFns } from "./CardTarjaSaiaJusta.vue?vue&type=template&id=2d8273c5&scoped=true"
import script from "./CardTarjaSaiaJusta.vue?vue&type=script&lang=js"
export * from "./CardTarjaSaiaJusta.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaSaiaJusta.vue?vue&type=style&index=0&id=2d8273c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8273c5",
  null
  
)

export default component.exports